/**
 * Admin-JWT во ВСЕХ запросах админки, идущих голым `fetch` (10.09.2026).
 *
 * 🔴 Зачем: роутер `/api_providers/*` закрыт `verify_admin` (Ф0 хотфикса мастера провайдеров,
 * до этого 31 эндпоинт отвечал кому угодно), а живая страница провайдеров, её список, карточка
 * и тестовые прогоны ходят голым `fetch` без заголовка — по админке таких вызовов 161.
 * Править сорок файлов по одному — тот самый класс «починил одну дверь из девяти», поэтому
 * заголовок ставится в одном месте, ровно как уже сделано для axios в `index.tsx`.
 *
 * 🔴 Только СВОЙ origin: относительные пути и абсолютные адреса этого же хоста. Чужому
 * серверу (вендор, CDN) админ-токен не нужен и отдавать его туда нельзя.
 */

const PATCHED = "__aimmAuthFetchPatched";

function isSameOrigin(url: string): boolean {
  // 🔴 Никакого спецслучая для строк, начинающихся со слэша: `//evil.example/x` —
  // валидный protocol-relative URL, ведущий на ЧУЖОЙ хост, и админ-токен уехал бы туда.
  // Разбираем всегда и сравниваем origin.
  try {
    return new URL(url, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
}

function urlOf(input: RequestInfo | URL): string {
  if (typeof input === "string") return input;
  if (input instanceof URL) return input.toString();
  return (input as Request).url || "";
}

export function installAuthFetch(): void {
  const w = window as any;
  if (w[PATCHED]) return; // повторная установка не наслаивает патч
  const original = window.fetch.bind(window);

  window.fetch = ((input: RequestInfo | URL, init?: RequestInit) => {
    const token = localStorage.getItem("authToken");
    if (!token || !isSameOrigin(urlOf(input))) return original(input as any, init);

    const headers = new Headers((init && init.headers) || (input instanceof Request ? input.headers : undefined));
    if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${token}`);
    return original(input as any, { ...(init || {}), headers });
  }) as typeof window.fetch;

  w[PATCHED] = true;
}
